import * as Sentry from '@sentry/vue'

export function registerSentry(app: any, router: any) {
  Sentry.init({
    app,
    dsn: 'https://51a8ae3fe55a08b8557dcc1d088378f8@o504872.ingest.sentry.io/4506506977345536',
    release: process.env.npm_package_version,
    environment: import.meta.env.VITE_ENVIRONMENT,
    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router)
      })
    ]
  })
}
